import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from '../../../../shared/utils.service';
import { AppService } from '../../../../app.service';
import { RBACService } from '../../../../shared/rbac.service';
import { ApiRequestService } from '../../../../shared/api-request.service';

@Component({
  selector: 'app-sites-eep-layout',
  templateUrl: './sites-eep-layout.component.html',
  styleUrls: ['./sites-eep-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesEepLayoutComponent implements OnInit {
  site_id: number;
  parent_site_id: number;

  isViewMode: boolean = false;

  // RBAC permission flags. Resolved once in ngOnInit().
  // Edit mode needs Sites Edit too, because the EEP text fields save through the site update endpoint.
  canEditEep: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public app: AppService,
    public utils: UtilsService,
    public rbac: RBACService,
    private api: ApiRequestService
  ) {}

  ngOnInit(): void {
    this.canEditEep = this.rbac.userCanAccess([
      RBACService.getPermission(RBACService.RBAC_F.F_SITES, RBACService.RBAC_A.A_EDIT),
      RBACService.getPermission(RBACService.RBAC_F.F_SITES_EEP, RBACService.RBAC_A.A_EDIT)
    ], true);

    // Deny when Sites View is missing OR the user holds neither EEP View nor EEP Edit.
    if (
      !this.rbac.userCanAccess([
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        )
      ]) ||
      !this.rbac.userCanAccess([
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES_EEP,
          RBACService.RBAC_A.A_VIEW
        ),
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES_EEP,
          RBACService.RBAC_A.A_EDIT
        )
      ])
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      this.utils.redirectByLastSegment('details');
      return;
    }

    // Check if we are in view mode. Extract it from the second last segment of the url.
    const action: string = this.router.url
      .split('?')[0]
      .split('/')
      .slice(-2, -1)[0];

    this.isViewMode = action === 'view';

    // Get the site id from the route params.
    const parent_id: number = Number(
      this.route.parent.snapshot.params['parent_id']
    );
    const child_id: number = Number(
      this.route.parent.snapshot.params['child_id']
    );

    // Check if we are updating a site or creating a new one.
    if (
      child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        parent_id)
    ) {
      // Store the site id.
      this.site_id = child_id ? child_id : parent_id;
      // If this is a child site, store the parent site id.
      if (child_id && parent_id) {
        this.parent_site_id = parent_id;
      }
    } else {
      // Get and store the parent site id if it is present.
      if (parent_id) {
        // Store the site id.
        this.parent_site_id = parent_id;
      }
    }
  }

  onExportEmergencyEvacuationPlan(): void {
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_VIEW
          ),
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES_EEP,
            RBACService.RBAC_A.A_VIEW
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      return;
    }

    this.api
      .makeRequest('get', `v1/sites/${this.site_id}/emergency-evacuation-plan`)
      .then(
        (response: any): void => {
          this.utils.openUrl(response.data.url);
        }
      );
  }

  protected readonly RBACService = RBACService;
}
